import { useState } from 'react'
import { useAuth, Toasty } from '@talktoast/shared'
import LoginForm from './LoginForm'
import SignUpForm from './SignUpForm'
import { Card, Tabs } from '@talktoast/ui'

export default function AuthScreen() {
  const [mode, setMode] = useState<'login' | 'signup'>('signup')
  const { createGuestSession, loading } = useAuth()

  const handleGuestContinue = async () => {
    try {
      await createGuestSession()
    } catch (error) {
      console.error('Failed to create guest session:', error)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-warm-cream via-white to-butter-cream flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* App Logo/Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center mb-4">
            <Toasty size="lg" alt="TalkToast" className="w-16 h-16" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">TalkToast</h1>
          <p className="text-gray-600">Your AI-powered meal planning assistant</p>
        </div>

        {/* Auth Card */}
        <Card variant="elevated">
          <Tabs
            tabs={[
              { id: 'signup', label: 'Get Started' },
              { id: 'login', label: 'Sign In' }
            ]}
            activeTab={mode}
            onChange={(tabId) => setMode(tabId as 'login' | 'signup')}
          />

          {/* Content */}
          <div className="mt-6">
            {mode === 'login' ? (
              <LoginForm
                onSwitchToSignUp={() => setMode('signup')}
                onGuestContinue={handleGuestContinue}
              />
            ) : (
              <SignUpForm
                onSwitchToLogin={() => setMode('login')}
                onGuestContinue={handleGuestContinue}
              />
            )}
          </div>
        </Card>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-gray-500">
          <p>
            By continuing, you agree to our{' '}
            <a href="#" className="text-toast-gold hover:underline">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="text-toast-gold hover:underline">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}